import React from "react";
import ChooseCtaTemplate from "./ChooseCtaTemplate";
import EditCtaTemplate from "./EditCtaTemplate";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";
import { VerticalTemplates } from "../../../../../services/Templates";

export default function CallToAction() {
  const {
    selectedTemplateKey,
    setSelectedTemplateKey,
    formData,
    setFormData,
    setFormSteps,
    setCurrentStep,
  } = useEditCtaContext();
  const onSelectedTemplate = (tempKey) => {
    setSelectedTemplateKey(tempKey);
    setFormData({
      ...formData,
      ...VerticalTemplates[tempKey].defaultValues,
    });
    setFormSteps(VerticalTemplates[tempKey].steps);
    setCurrentStep(VerticalTemplates[tempKey].steps[0]);
  };

  return (
    <div className="flex-1 flex flex-col gap-6 h-full">
      {selectedTemplateKey === "" && (
        <ChooseCtaTemplate onSelectedTemplate={onSelectedTemplate} />
      )}

      {selectedTemplateKey !== "" && <EditCtaTemplate />}
    </div>
  );
}
